import React from "react";

const WatchVoteYear = ({ voteAverage, releaseDate, className }) => {
  return (
    <div className={`flex items-center gap-x-5 ${className}`}>
      <div className="flex vote gap-x-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          className={`fill-[#6680c0]`}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0312 1C13.0666 1 14.6926 5.69969 15.2795 7.50668C15.4141 7.92126 15.7943 8.20684 16.23 8.22162C18.1151 8.28556 23 8.55772 23 9.66144C23 10.7495 19.5188 13.4853 18.0955 14.5583C17.7427 14.8243 17.5982 15.2836 17.734 15.704C18.3132 17.4975 19.7048 22.1483 18.8117 22.8815C17.9323 23.6034 14.1749 20.7486 12.6485 19.5286C12.2692 19.2254 11.7305 19.2251 11.3511 19.528C9.82346 20.7477 6.06764 23.6035 5.25065 22.8815C4.41962 22.1471 5.73815 17.4816 6.28237 15.6949C6.40915 15.2786 6.26319 14.8287 5.91569 14.5668C4.4996 13.4997 1 10.7523 1 9.66144C1 8.55659 5.89498 8.285 7.77586 8.22142C8.20861 8.2068 8.58723 7.92462 8.72415 7.51385C9.32468 5.71216 10.9944 1 12.0312 1Z"
            stroke="#6680c0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="tracking-wider">
          {Math.round(voteAverage * 10) / 10 || "0.0"}
        </span>
      </div>
      <div className="flex release-date gap-x-2">
        <svg
          width="18"
          height="20"
          viewBox="0 0 24 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C8.55229 0 9 0.447715 9 1V2.08526C9.91022 2.02588 10.9077 2 12 2C13.0923 2 14.0898 2.02588 15 2.08526V1C15 0.447715 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V2.29284C21.5655 2.98124 23.3272 5.03464 23.8321 10C23.8648 10.321 23.8922 10.6542 23.9147 11C23.9357 11.3219 23.9525 11.6547 23.9655 11.9987C23.9892 12.6276 24 13.294 24 14C24 23.882 21.882 26 12 26C2.118 26 0 23.882 0 14C0 13.294 0.0108119 12.6276 0.0344942 11.9987C0.0474512 11.6547 0.0642607 11.3219 0.0852604 11C0.107819 10.6542 0.135213 10.321 0.16786 10C0.672822 5.03464 2.43455 2.98124 7 2.29284V1C7 0.447715 7.44772 0 8 0ZM7 4.31862C5.65606 4.54689 4.74838 4.897 4.10819 5.36634C3.1636 6.05884 2.48259 7.275 2.17921 10H21.8208C21.5174 7.275 20.8364 6.05884 19.8918 5.36634C19.2516 4.897 18.3439 4.54689 17 4.31862V5C17 5.55228 16.5523 6 16 6C15.4477 6 15 5.55228 15 5V4.09118C14.1318 4.0305 13.1387 4 12 4C10.8613 4 9.86819 4.0305 9 4.09118V5C9 5.55228 8.55229 6 8 6C7.44772 6 7 5.55228 7 5V4.31862ZM22 14C22 13.2846 21.9886 12.6193 21.9641 12H2.03593C2.01144 12.6193 2 13.2846 2 14C2 16.4249 2.13254 18.2369 2.43771 19.6101C2.73783 20.9605 3.17768 21.7608 3.70846 22.2915C4.23924 22.8223 5.03949 23.2622 6.38993 23.5623C7.76307 23.8675 9.57515 24 12 24C14.4249 24 16.2369 23.8675 17.6101 23.5623C18.9605 23.2622 19.7608 22.8223 20.2915 22.2915C20.8223 21.7608 21.2622 20.9605 21.5623 19.6101C21.8675 18.2369 22 16.4249 22 14Z"
            fill="#6680c0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 16C5 15.4477 5.44772 15 6 15H9C9.55228 15 10 15.4477 10 16C10 16.5523 9.55228 17 9 17H6C5.44772 17 5 16.5523 5 16ZM15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H18C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15H15ZM15 19C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21H18C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19H15ZM6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H9C9.55228 21 10 20.5523 10 20C10 19.4477 9.55228 19 9 19H6Z"
            fill="#6680c0"
          />
        </svg>
        <p>{new Date(releaseDate).getFullYear() || "2013"}</p>
      </div>
    </div>
  );
};

export default WatchVoteYear;
